import React from 'react';
import { ListItem } from '@mui/material';

const DSListItem = (props: React.ComponentProps<typeof ListItem>) => {
  return <ListItem {...props} />;
};

export default DSListItem;
